export default __webpack_public_path__ + "static/media/eg.5398d660.svg";